'use client';

import { Flex, Text } from '@skin-seoul/design-system';
import { CLASSNAME } from '@skin-seoul/service';
interface CustomCheckboxProps {
  checked: boolean;
  label: string;
  onChange: (checked: boolean) => void;
}

/**
 * Used for filter selections in collections and other multi-select scenarios
 */
const CustomCheckbox = ({
  checked,
  label,
  onChange
}: CustomCheckboxProps) => {
  return <Flex align="center" gap={3} cursor="pointer" onClick={() => onChange(!checked)} paddingY={1} data-sentry-element="Flex" data-sentry-component="CustomCheckbox" data-sentry-source-file="CustomCheckbox.tsx">
      <Flex width="16px" height="16px" borderRadius="4px" backgroundColor={checked ? 'primary.500' : 'transparent'} border={checked ? 'none' : '1px solid'} borderColor={checked ? 'transparent' : 'neutral.100'} alignItems="center" justifyContent="center" flexShrink={0} data-sentry-element="Flex" data-sentry-source-file="CustomCheckbox.tsx">
        {checked && <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M10 3L4.5 8.5L2 6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>}
      </Flex>
      <Text textStyle="sm" color="neutral.700" fontWeight="400" className={CLASSNAME.NOT_TRANSLATE} data-sentry-element="Text" data-sentry-source-file="CustomCheckbox.tsx">
        {label}
      </Text>
    </Flex>;
};
export default CustomCheckbox;